import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';

function TermsOfService() {
  const termsText = `
    Terms of Service
    Last Updated: March 18, 2025

    Welcome to Trideca Labs LLC! These Terms of Service ("Terms") govern your use of our website and services. By accessing or using our services, you agree to be bound by these Terms.

    1. Use of Services
    Our services are intended for users who are at least 18 years old. You agree to use our services only for lawful purposes.

    2. Intellectual Property
    All content on this site, including text, graphics, and code, is the property of Trideca Labs LLC and protected by copyright laws.

    3. Limitation of Liability
    Trideca Labs LLC is not liable for any damages arising from the use of our services.

    4. Changes to Terms
    We may update these Terms from time to time. Continued use of our services constitutes acceptance of the updated Terms.

    For questions, contact us at: tridecalabs@gmail.com
  `;

  return (
    <div className="matrix-text terms-container">
      <pre className="terms-text">{termsText}</pre>
      <Link to="/" className="terms-link">Back to Home</Link>
    </div>
  );
}

export default TermsOfService;